import { Menu, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';


export const Progetto = ()=>{
    const menu = (
        <Menu>
            <Menu.Item key="0">
                <a>Fuoco e acciaio</a>
            </Menu.Item>
        </Menu>
    );
    return(
        <Dropdown overlay={menu} trigger={['click']}>
            <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                Progetto <DownOutlined />
            </a>
        </Dropdown>
    )
}
